export const STORE_SERVICE_PREFIX = "StoreService";

export const STORE_SERVICE_CLASSES = {
  link: `${STORE_SERVICE_PREFIX}-link`,
  linkText: `${STORE_SERVICE_PREFIX}-linkText`,
  serviceImage: `${STORE_SERVICE_PREFIX}-serviceImage`,
  serviceInfoBlock: `${STORE_SERVICE_PREFIX}-serviceInfoBlock`,
  serviceDetailLink: `${STORE_SERVICE_PREFIX}-serviceDetailLink`,
  title: `${STORE_SERVICE_PREFIX}-title`,
  subtitle: `${STORE_SERVICE_PREFIX}-subtitle`,
};
